<div class="banner-image" *ngIf="validate()" [ngClass]="data.class" loading="lazy">
  <img [src]="data.url" alt="image">
</div>
